import { Button } from "components/Button/Button"
import { BaseLayout } from "components/BaseLayout/BaseLayout"
import { Empty } from "components/Empty/Empty"
import { UnauthorizedIcon } from "icons/UnauthorizedIcon"
import { useNavigate } from "react-router"

export const Unauthorized = () => {
	const navigate = useNavigate()

	return (
		<BaseLayout className="lg:grid-cols-1">
			<BaseLayout.Header />

			<BaseLayout.Main>
				<Empty
					Icon={UnauthorizedIcon}
					title="No permission"
					description="You currently do not have permission to view the page."
				>
					<Button
						size="large"
						onClick={() => {
							navigate("/check-authorization", { replace: true })
						}}
					>
						Go to home
					</Button>
				</Empty>
			</BaseLayout.Main>
		</BaseLayout>
	)
}
